import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const getLoads = (params) => api.get("/loads", { params }).then((r) => r.data);
export const postLoad = (data) => api.post("/loads", data).then((r) => r.data);
export const requestLoad = (data) => api.post("/load-requests", data).then((r) => r.data);
export const getAdminLoads = () => api.get("/admin/loads").then((r) => r.data);
export const getSubmissions = () => api.get("/admin/submissions").then((r) => r.data);
export const updateLoadStatus = (id, status) =>
  api.patch(`/admin/loads/${id}/status`, { status }).then((r) => r.data);

export const EQUIPMENT = ["Expedited", "Hotshot", "Dry Van", "Flatbed", "Reefer", "OTR"];
export const OWNER = {
  name: "[Owner Name]",
  phone: "(346) 820-6604",
  email: "support@coastalexpeditelogistics.com",
  location: "Houston, TX",
  address: "801 Travis St, Houston, TX 77002",
};
